export const publicRoutes = ['/mailing/email-address/confirm', 'share']
